export const staffSpace = 250;
export const quarterNoteWidth = 295;
export const barlineWidth = 36;
export const stemWidth = 15;
export const staffLineWidth = 32;
export const staffLineColor = "#404040";
export const symbolColor = "#000000";

/**
 * Bravura metadata
 * @see https://raw.githubusercontent.com/steinbergmedia/bravura/master/redist/bravura_metadata.json
 * @see https://w3c.github.io/smufl/gitbook/specification/glyphswithanchors.html
 * @see https://w3c.github.io/smufl/gitbook/specification/glyph-registration-notes-flags.html
 */
export const metadata = {
  glyphsWithAnchors: {
    noteheadBlack: {
      stemDownNW: {
        x: 0.0,
        y: -0.168,
      },
      stemUpSE: {
        x: 1.18,
        y: 0.168,
      },
    },
  },
} as const;
